import { io } from "socket.io-client";

import { API_URL } from "src/Common/function";
import TokenService from "src/Services/API/token.service";

let ticketMessagesSocket;
let refCount = 0;

const getTicketMessagesSocket = () => {
  if (!ticketMessagesSocket) {
    ticketMessagesSocket = io(API_URL, {
      autoConnect: false,
      transports: ["websocket"],
    });
  }

  return ticketMessagesSocket;
};

const connectTicketMessagesSocket = () => {
  const socket = getTicketMessagesSocket();
  socket.auth = {
    token: TokenService.getLocalAccessToken(),
  };

  if (!socket.connected) {
    socket.connect();
  }

  refCount++;
  return socket;
};

const disconnectTicketMessagesSocket = () => {
  refCount = Math.max(0, refCount - 1);
  if (refCount === 0 && ticketMessagesSocket?.connected) {
    ticketMessagesSocket.disconnect();
  }
};

export {
  getTicketMessagesSocket,
  connectTicketMessagesSocket,
  disconnectTicketMessagesSocket,
};
